{
  "salon-details-footer": {
    "text": {
      "contact-salon": "CONTACTER LE SALON",
      "closed": "Fermé",
      "opening-time": "HEURE D'OUVERTURE",
      "salon-location": "EMPLACEMENT DU SALON"
    }
  }
}
